import Paging from './Paging'

export default Paging
